module.exports = __webpack_public_path__ + "img/logo.46f01f23.webp";